// Navigation helper utilities for web app

// Get locationOn state from localStorage
export const getLocationOn = () => {
  try {
    const locationOn = localStorage.getItem('tellmiz_locationOn');
    return locationOn === 'true';
  } catch (error) {
    console.error('Error getting locationOn:', error);
    return false;
  }
};

// Set locationOn state in localStorage
export const setLocationOn = (value) => {
  try {
    localStorage.setItem('tellmiz_locationOn', value.toString());
  } catch (error) {
    console.error('Error setting locationOn:', error);
  }
};

// Get user data from localStorage
export const getUserFromStorage = () => {
  try {
    const user = localStorage.getItem('tellmiz_user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Error getting user:', error);
    return null;
  }
};

// Get unread messages count
export const getUnreadMessagesCount = () => {
  try {
    const count = localStorage.getItem('tellmiz_unreadMessagesCount');
    return count ? parseInt(count, 10) : 0;
  } catch (error) {
    console.error('Error getting unread messages count:', error);
    return 0;
  }
};

// Color constants matching mobile app
export const Colors = {
  PRIMARY: '#005499',
  LIGHTPRIMARY: '#0077B6',
  SECONDARY: '#0C0D34',
  WHITE: '#FFFFFF',
  GREY: '#F4F0EF',
  DARK_GREY: '#808080',
  DANGER: '#FF0058',
  YELLOW: '#EAC33A',
  GRAY_YELLOW: '#cfbf8a',
  DARKBLUE: '#4C7D91',
  CUSTOM_GREY: '#545454',
  CUSTOM_YELLOW: '#FFD600',
};

// Get primary color based on locationOn state
export const getPrimaryColor = () => {
  return getLocationOn() ? Colors.CUSTOM_YELLOW : Colors.PRIMARY;
};

// Uppercase first letter helper
export const uppercaseFirstLetter = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

















